export const list = [
    {
        userCreated: 0,
        ID: 170509,
        financialFactorID: null,
        bankFinancialFactorID: 159432,
        code: null,
        customerFirstName: null,
        customerName: "کاربر 1",
        customerLastName: null,
        customerUserName: "09371000000",
        customerCell: null,
        postalCode: null,
        address: null,
        provinceID: 0,
        cityID: 0,
        totalPaid: 683100,
        totalPrice: null,
        totalProductCount: null,
        totalPriceWithTax: null,
        orderStatus: 2,
        orderStatusName: "پرداخت شده بانکی",
        paiedType: null,
        paiedStatus: null,
        transStatus: 1,
        transStatusName: null,
        orderDateTime: "1401/09/13 18:48:29",
        postCompanyID: "1",
        discountCodePrice: "240000",
        commerceDiscountPrice: "",
    },
    {
        userCreated: 0,
        ID: 170508,
        financialFactorID: null,
        bankFinancialFactorID: 159431,
        code: null,
        customerFirstName: null,
        customerName: "کاربر 2",
        customerLastName: null,
        customerUserName: "09109999999",
        customerCell: null,
        postalCode: null,
        address: null,
        provinceID: 0,
        cityID: 0,
        totalPaid: 495600,
        totalPrice: null,
        totalProductCount: null,
        totalPriceWithTax: null,
        orderStatus: 1,
        orderStatusName: "پرداخت شده بانکی",
        paiedType: null,
        paiedStatus: null,
        transStatus: 2,
        transStatusName: null,
        orderDateTime: "1401/09/13 18:48:18",
        postCompanyID: "3",
        discountCodePrice: "240000",
        commerceDiscountPrice: "",
    },
    {
        userCreated: 0,
        ID: 170507,
        financialFactorID: null,
        bankFinancialFactorID: 159430,
        code: null,
        customerFirstName: null,
        customerName: "کاربر 3",
        customerLastName: null,
        customerUserName: "09333333333",
        customerCell: null,
        postalCode: null,
        address: null,
        provinceID: 0,
        cityID: 0,
        totalPaid: 495000,
        totalPrice: null,
        totalProductCount: null,
        totalPriceWithTax: null,
        orderStatus: 0,
        orderStatusName: "پرداخت شده بانکی",
        paiedType: null,
        paiedStatus: null,
        transStatus: 0,
        transStatusName: null,
        orderDateTime: "1401/09/13 18:47:48",
        postCompanyID: "3",
        discountCodePrice: "240000",
        commerceDiscountPrice: "",
    },
    {
        userCreated: 0,
        ID: 170505,
        financialFactorID: null,
        bankFinancialFactorID: 159428,
        code: null,
        customerFirstName: null,
        customerName: "کاربر 4",
        customerLastName: null,
        customerUserName: "09337777777",
        customerCell: null,
        postalCode: null,
        address: null,
        provinceID: 0,
        cityID: 0,
        totalPaid: 670500,
        totalPrice: null,
        totalProductCount: null,
        totalPriceWithTax: null,
        orderStatus: 1,
        orderStatusName: "پرداخت شده بانکی",
        paiedType: null,
        paiedStatus: null,
        transStatus: 0,
        transStatusName: null,
        orderDateTime: "1401/09/13 18:41:09",
        postCompanyID: "3",
        discountCodePrice: "240000",
        commerceDiscountPrice: "",
    },
    {
        userCreated: 0,
        ID: 170504,
        financialFactorID: null,
        bankFinancialFactorID: 159427,
        code: null,
        customerFirstName: null,
        customerName: "کاربر 5",
        customerLastName: null,
        customerUserName: "09160000000",
        customerCell: null,
        postalCode: null,
        address: null,
        provinceID: 0,
        cityID: 0,
        totalPaid: 1090000,
        totalPrice: null,
        totalProductCount: null,
        totalPriceWithTax: null,
        orderStatus: 1,
        orderStatusName: "پرداخت شده بانکی",
        paiedType: null,
        paiedStatus: null,
        transStatus: 2,
        transStatusName: null,
        orderDateTime: "1401/09/13 18:40:07",
        postCompanyID: "3",
        discountCodePrice: "240000",
        commerceDiscountPrice: "",
    },
    {
        userCreated: 0,
        ID: 170503,
        financialFactorID: null,
        bankFinancialFactorID: 159426,
        code: null,
        customerFirstName: null,
        customerName: "کاربر 6",
        customerLastName: null,
        customerUserName: "09051000000",
        customerCell: null,
        postalCode: null,
        address: null,
        provinceID: 0,
        cityID: 0,
        totalPaid: 7179135,
        totalPrice: null,
        totalProductCount: null,
        totalPriceWithTax: null,
        orderStatus: 2,
        orderStatusName: "پرداخت شده بانکی",
        paiedType: null,
        paiedStatus: null,
        transStatus: 0,
        transStatusName: null,
        orderDateTime: "1401/09/13 18:39:55",
        postCompanyID: "1",
        discountCodePrice: "240000",
        commerceDiscountPrice: "",
    },
    {
        userCreated: 0,
        ID: 170502,
        financialFactorID: null,
        bankFinancialFactorID: 159425,
        code: null,
        customerFirstName: null,
        customerName: "کاربر 7",
        customerLastName: null,
        customerUserName: "09199999999",
        customerCell: null,
        postalCode: null,
        address: null,
        provinceID: 0,
        cityID: 0,
        totalPaid: 6006320,
        totalPrice: null,
        totalProductCount: null,
        totalPriceWithTax: null,
        orderStatus: 1,
        orderStatusName: "پرداخت شده بانکی",
        paiedType: null,
        paiedStatus: null,
        transStatus: 1,
        transStatusName: null,
        orderDateTime: "1401/09/13 18:39:22",
        postCompanyID: "3",
        discountCodePrice: "840000",
        commerceDiscountPrice: "",
    },
    {
        userCreated: 0,
        ID: 170501,
        financialFactorID: null,
        bankFinancialFactorID: 159424,
        code: null,
        customerFirstName: null,
        customerName: "کاربر 8",
        customerLastName: null,
        customerUserName: "09105555555",
        customerCell: null,
        postalCode: null,
        address: null,
        provinceID: 0,
        cityID: 0,
        totalPaid: 3400920,
        totalPrice: null,
        totalProductCount: null,
        totalPriceWithTax: null,
        orderStatus: 1,
        orderStatusName: "پرداخت شده بانکی",
        paiedType: null,
        paiedStatus: null,
        transStatus: 1,
        transStatusName: null,
        orderDateTime: "1401/09/13 18:38:54",
        postCompanyID: "3",
        discountCodePrice: "740000",
        commerceDiscountPrice: "",
    },
    {
        userCreated: 0,
        ID: 170499,
        financialFactorID: null,
        bankFinancialFactorID: 159423,
        code: null,
        customerFirstName: null,
        customerName: "کاربر 9",
        customerLastName: null,
        customerUserName: "09372222222",
        customerCell: null,
        postalCode: null,
        address: null,
        provinceID: 0,
        cityID: 0,
        totalPaid: 2003400,
        totalPrice: null,
        totalProductCount: null,
        totalPriceWithTax: null,
        orderStatus: 0,
        orderStatusName: "پرداخت شده بانکی",
        paiedType: null,
        paiedStatus: null,
        transStatus: 0,
        transStatusName: null,
        orderDateTime: "1401/09/13 18:37:39",
        postCompanyID: "1",
        discountCodePrice: "240000",
        commerceDiscountPrice: "",
    },
    {
        userCreated: 0,
        ID: 170498,
        financialFactorID: null,
        bankFinancialFactorID: 159422,
        code: null,
        customerFirstName: null,
        customerName: "کاربر 10",
        customerLastName: null,
        customerUserName: "09218888888",
        customerCell: null,
        postalCode: null,
        address: null,
        provinceID: 0,
        cityID: 0,
        totalPaid: 670500,
        totalPrice: null,
        totalProductCount: null,
        totalPriceWithTax: null,
        orderStatus: 1,
        orderStatusName: "پرداخت شده بانکی",
        paiedType: null,
        paiedStatus: null,
        transStatus: 1,
        transStatusName: null,
        orderDateTime: "1401/09/13 18:37:32",
        postCompanyID: "3",
        discountCodePrice: "240000",
        commerceDiscountPrice: "",
    },
]

export const detail = {
    orderDetailReceiver: {
        receiverName: "کاربر ",
        receiverPhone: "0912",
        receiverMobile: "0912",
        receiverPostalCode: "123",
        receiverAddress: "طهران",
        receiverProvince: "طهران",
        receiverProvinceID: 29,
        receiverCity: "طهران",
        receiverCityID: 2573,
        totalPay: null,
        totalPrice: null,
        date: null,
        name: "کاربر ",
        username: "0912",
        email: null,
        phone: null,
        mobile: "0912",
        barcodeName: null,
        companyPostID: 0,
    },
    orderProductsTotal: {
        transactionID: 159432,
        orderID: 170509,
        totalTax: "0",
        totalPrice: "683100",
        totalWeight: "350",
        postCost: "240000",
        totalDiscount: "696900",
        totalPay: "683100",
        totalBankPay: null,
        totalWalletPay: null,
    },
    paymentDetails: {
        status: true,
        bankResponse: "",
        payDate: "1401/09/10 ",
    },
    orderProducts: [
        {
            num: 1,
            commerceID: 77897,
            productID: 10972,
            orderID: 170509,
            name: "سرم آبرسان ایمیجز مدل Blood Orange ظرفیت 100 میلی لیتر",
            brandName: "ایمیجز",
            picLink:
                "https://joeschmoe.io/api/v1/random",
            count: 1,
            sort: 0,
            brandSort: 0,
            discount: 356400,
            price: "200 تومان ",
            title: null,
            tax: "0",
            totalWeight: "300",
            totalPrice: "2000",
            barcodesJson: null,
            campainProducts: [],
        },
        {
            num: 2,
            commerceID: 77801,
            productID: 10335,
            orderID: 170509,
            name: "ماسک صورت ورقه ای حاوی گل رز سادور وزن 25 گرمی",
            brandName: "سادور",
            picLink:
                "https://joeschmoe.io/api/v1/random",
            count: 1,
            sort: 0,
            brandSort: 0,
            discount: 100500,
            price: "100 تومان ",
            title: null,
            tax: "0",
            totalWeight: "50",
            totalPrice: "1000",
            barcodesJson: null,
            campainProducts: [],
        },
    ],
    barcodes: [],
    orderLogs: [],
    transactionLogs: [],
    discountUsed: [
        {
            title: "ارسال رایگان ",
            discountCode: "",
            startDateTime: "1401-09-13 10:54:49",
            endDateTime: "1401-09-30 23:59:49",
            discountType: "قیمت پستی",
            totalDiscount: 240000,
            isPercent: true,
            discount: 100,
        },
    ],
    campainProducts: [],
}
